import { api } from '@/shared/api';
import { AxiosError } from 'axios';

/**
 * 荷物を追加する
 * @param applicationId - 申し込みID
 * @param luggageQrCode - 荷物QRコード
 * @returns 成功時は空のレスポンス
 */
export const addLuggage = async (applicationId: string, luggageQrCode: string): Promise<void> => {
    try {
        await api.post('/applications/{application_id}/luggages/additional-luggage', {
            path: { application_id: applicationId },
            body: { luggage_qr_code: luggageQrCode },
        });
    } catch (error) {
        const axiosError = error as AxiosError<{ message?: string }>;
        const message = axiosError.response?.data?.message;

        if (message) {
            throw new Error(message);
        }

        throw new Error('荷物の追加中にエラーが発生しました。');
    }
};
